/**
 * Wrapper for the fetch function.
 *
 * This allows fetch to be injected as a dependency without shitting the bed.
 *
 * @param url
 * @param params
 * @return {Promise<Response>}
 */
const fetchWrapper = (url, params) => fetch(url, params)

export default fetchWrapper
